"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAui, AuiProvider, Derived } from "@assistant-ui/store";
export const MessageByIndexProvider = ({ index, children }) => {
    const aui = useAui({
        message: Derived({
            source: "thread",
            query: { type: "index", index },
            get: (aui) => aui.thread().message({ index }),
        }),
        composer: Derived({
            source: "message",
            query: {},
            get: (aui) => aui.thread().message({ index }).composer,
        }),
    });
    return _jsx(AuiProvider, { value: aui, children: children });
};
//# sourceMappingURL=MessageByIndexProvider.js.map